import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { MessageSquare, Phone } from "lucide-react";

/**
 * Phone-only sticky action bar.
 *
 * On a desktop these pages carry a sticky quote form in the right rail; on a phone
 * that rail collapses to the very bottom of a long page, so the two things a
 * customer actually wants - a quote or a phone call - were a thousand pixels of
 * scrolling away. Appears once you've started reading.
 */
export default function MobileActionBar({ to, phone, label = "Get a fitted quote" }) {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 320);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <div
      className="fixed inset-x-0 bottom-0 z-40 border-t px-3 pb-[max(0.75rem,env(safe-area-inset-bottom))] pt-3 transition-transform duration-300 lg:hidden"
      style={{
        borderColor: "rgba(255,255,255,0.09)",
        background: "rgba(10,13,11,0.94)",
        backdropFilter: "blur(12px)",
        transform: show ? "translateY(0)" : "translateY(110%)",
      }}
      data-testid="mobile-action-bar"
    >
      <div className="flex items-center gap-2">
        <Link
          to={to}
          className="btn-gold min-h-[48px] flex-1 text-sm"
          data-testid="mobile-action-quote"
        >
          <MessageSquare className="h-4 w-4" /> {label}
        </Link>
        {phone && (
          <a
            href={`tel:${phone.replace(/[^\d+]/g, "")}`}
            className="btn-outline-nq min-h-[48px] px-4"
            aria-label={`Call ${phone}`}
            data-testid="mobile-action-call"
          >
            <Phone className="h-4 w-4" />
          </a>
        )}
      </div>
    </div>
  );
}
